import React from 'react';
import * as Styles from './EmptyProductsV2.styles';
import {
  WhiteCard, Title, ItemsRow, CardItem, CardContent, CardHeader, CardTitle, CardDescription, CardCtaWrapper,
} from '../NewHomeLayoutHandler/NewHomeLayoutHandler.styles';
import { Button, IconArrow } from 'gatorcomponents';

const EmptyProductsV2 = ({ locale }) => (
  <WhiteCard>
    <Title>{locale.title}</Title>

    <ItemsRow $flexDirection="column">
      {locale.items.map(item => (
        <CardItem key={item.id}>
          <CardContent>
            <CardHeader>
              <Styles.CardIcon>
                {item.icon}
              </Styles.CardIcon>
              <CardTitle>{item.title}</CardTitle>
            </CardHeader>
            <CardDescription>{item.description}</CardDescription>
            <CardCtaWrapper>
              <Button
                label={item.cta}
                onClick={() => window.open(item.link, '_blank')}
                variant="text"
                iconRight={<IconArrow direction="right" color="primaryBlue" />}
                version="v2"
              />
            </CardCtaWrapper>
          </CardContent>
        </CardItem>
      ))}
    </ItemsRow>
  </WhiteCard>
);

export default EmptyProductsV2;
